module.exports = __webpack_public_path__ + "static/media/VIDRIO.7550266c.png";